<template>
    <div class="allot_ad_dialog_mask"  v-if="dialogShow">
    <el-card class="allot_ad_dialog">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">分配广告</span>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="6"><span>设备编号</span></el-col>
                <el-col :span="14" style="text-align: left;">
                    <div>
                        <span v-for="item in deviceList" style="display: inline-block;margin-left: 10px; word-wrap:break-word;white-space:normal;">{{item.num}}</span>
                    </div>

                </el-col>
            </el-row>
             <el-row>
                <el-col :span="6"><span>广告编号</span></el-col>
                <el-col :span="14" style="text-align: left;">
                     <div>
                        <span v-for="item in adlist" style="display: inline-block;margin-left: 10px; word-wrap:break-word;white-space:normal;">{{item.num}}</span>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><span>开播日期</span></el-col>
                <el-col :span="14">
                    <el-date-picker
                        v-model="startDate"
                        :clearable=false
                        :editable=false
                        format='yyyy-MM-dd'
                        type="date"
                        placeholder="开播日期"
                        :picker-options="pickerStartDate">
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><span>停播日期</span></el-col>
                <el-col :span="14"><el-date-picker
                    v-model="endDate"
                    :clearable=false
                    :editable=false
                    format='yyyy-MM-dd'
                    type="date"
                    placeholder="停播日期"
                    :picker-options="pickerEndDate">
                </el-date-picker></el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><span>播放日期</span></el-col>
                <el-col :span="14"><el-date-picker
                    v-model="openDate"
                    :clearable=false
                    :editable=false
                    format='yyyy-MM-dd'
                    type="date"
                    placeholder="播放日期"
                    :picker-options="pickerOpenDate">
                </el-date-picker></el-col>
            </el-row>

            <el-row>
               <el-col :span="6"><span>播放时长(s)</span></el-col>
               <el-col :span="14" style="text-align: left;">
                    <div>
                       <el-input  style="display: inline-block;margin-left: 10px; word-wrap:break-word;white-space:normal;" v-model='duration'></el-input>
                   </div>
               </el-col>
           </el-row>

            <el-row>
                <el-col :span="18" :offset="3">
                    <el-button type="info" @click="allotBtn" style="width: 100%;" :loading="loading">确认分配</el-button>
                </el-col>
            </el-date-picker></el-col>
            </el-row>
        </div>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'
    import {getDateforNum, formatDate} from '../../js/tool'
    export default {
      props: ['allotDialogShow', 'deviceList', 'adlist', 'allotType'],
      data () {
        return {
          addShowOk: this.addShow,
          startDate: getDateforNum(1),
          endDate: getDateforNum(30),
          openDate: getDateforNum(1),
          pickerStartDate: {
            disabledDate (time) {
              return time.getTime() < Date.now() - 8.64e7
            }
          },
          pickerEndDate: {
            disabledDate (time) {
              return time.getTime() < Date.now() - 8.64e7
            }
          },
          pickerOpenDate: {
            disabledDate (time) {
              return time.getTime() < Date.now() - 8.64e7
            }
          },
          loading: false,
          allotFinish: false,
          duration: 10
        }
      },
      created: function () {

      },
      computed: {
        dialogShow: function () {
          return this.allotDialogShow
        }
      },
      methods: {
        boxColose (tType) {
          this.$emit('closeAllotPicVideoDialog', tType)
        },
        allotBtn () {
          for (var i = 0; i < this.adlist.length; i++) {
            for (var j = 0; j < this.deviceList.length; j++) {
              if (i === (this.adlist.length - 1) && j === (this.deviceList.length - 1)) {
                this.allotFinish = true
              }
              this.allotRes(this.adlist[i].num, this.deviceList[j].num, formatDate(this.startDate, 'yyyy-MM-dd') +
               ' 00:00:00', formatDate(this.endDate, 'yyyy-MM-dd') + ' 00:00:00',
                formatDate(this.openDate, 'yyyy-MM-dd') + ' 00:00:00', this.duration)
            }
          }
        },
        allotRes (mAdId, mDeviceId, mOntime, mOfftime, mPlaydate, mDuration) {
          this.loading = true
          var _this = this
          var params = {
            materialid: mAdId,
            deviceCode: mDeviceId,
            ontime: mOntime,
            offtime: mOfftime,
            duration: mDuration,
            playdate: mPlaydate
          }
          var url = '/device/setAdResources'
          if (this.allotType == "picFirst"){
            url = 'device/first/setAdResources'
          }else  if (this.allotType == "picFu"){
            url = 'device/fu/setAdResources'
          }

          $axios.post(url, params, 'headers', function (res) {
            _this.loading = false
            _this.table_loading = false
            if (res && res.resultStatus === true) {
              if (_this.allotFinish) {
                _this.$message({
                  type: 'success',
                  duration: 1000 * 5,
                  message: '分配广告成功!'
                })
                _this.boxColose(true)
              } else {
                _this.$message({
                  type: 'success',
                  duration: 1000 * 1,
                  message: '分配广告成功!'
                })
              }
            } else {
              if (_this.allotFinish) {
                _this.$message({
                  type: 'error',
                  duration: 1000 * 5,
                  message: '分配广告失败!' + res.errorMessage
                })
                _this.boxColose(true)
              } else {
                _this.$message({
                  type: 'error',
                  duration: 1000 * 1,
                  message: '分配广告失败!' + res.errorMessage
                })
              }
            }
          })
        }
      }
    }
</script>
<style lang="scss">
  .allot_ad_dialog_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;

      .allot_ad_dialog {
        width: 400px;
        top: 20%;
        left: 50%;
        z-index: 101;
        margin-left: -250px;
        position: fixed;

        .el-card__header {
          padding: 10px
        }
        .content {
            padding: 20px 0 0 0;

            .el-row {
                padding: 10px 0;

                .el-col:first-child {
                    text-align: right;
                    line-height: 36px
                }
                .el-col:last-child {
                    padding-left: 15px
                }
            }
        }
      }
  }
</style>



// WEBPACK FOOTER //
// src/page/deviceMgr/allotPicVideoDialog.vue